import moment from 'moment'
import { SubmitProposalClientRequest } from '../../../@types/SubmitProposal'
import { ENV } from '../../../Environment'
import { FormValuesFormalizationProps } from '../../../Pages/Formalization'
import { usePaymentConfirmationStore } from '../../../Stores/paymentConfirmationStore'
import { usePaymentStore } from '../../../Stores/paymentStore'
import { useAcceptConditionsStore } from '../../../Stores/useAcceptConditionsStore'
import { useConsentsStore } from '../../../Stores/useConsentsStore'
import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'
import { useGetAdditionalEntityDetailsStore } from '../../../Stores/useGetAdditionalEntityDetailsStore'
import { useRunPetisSimulationStore } from '../../../Stores/useRunPetisSimulationStore'
import { usePolicyholderPayload } from './usePolicyholderPayload'

export const useSubmitProposalPayload = () => {
  const { policyholderAdditionalDetails } = useGetAdditionalEntityDetailsStore()
  const { acceptConditions } = useAcceptConditionsStore()
  const { isSignatureDigital } = usePaymentConfirmationStore()
  const { addedIbanList, selectedIBAN } = usePaymentStore()
  const { runPetisSimulation } = useRunPetisSimulationStore()
  const { consents } = useConsentsStore()
  const { createProposal } = useCreateProposalStore()
  const { policyholderPayload } = usePolicyholderPayload()

  const handleSubmitProposalPayload = (
    formValues: FormValuesFormalizationProps,
  ) => {
    const submitProposalPayload: SubmitProposalClientRequest = {
      accessType: 'S',
      branchCode: ENV().BranchCode, //TODO: Review
      coreSystem: ENV().CoreSystem,
      originTemplate: '', //TODO: No data available, review
      // new ones
      applicationCode: ENV().ApplicationCode || '',
      processNumber:
        runPetisSimulation?.runPetisSimulationResponse?.quoteId || '',
      chosenCollectionIban: selectedIBAN || '',
      isNewIBAN: addedIbanList?.includes(selectedIBAN || ''),
      consentsList: consents?.map((consent) => {
        return {
          legalConsentGroupCode: '', //TODO: Do not have this data
          legalConsentGroupDescription: '', //TODO: Do not have this data
          legalConsentLegalCompanyCode: '', //TODO: Do not have this data
          legalConsentLegalCompanyDescription: '', //TODO: Do not have this data
          legalConsentCode: consent?.legalConsentCode || '',
          legalConsentCodeDescription: '', //TODO: Do not have this data
          legalConsentTitle: consent?.legalConsentTitle || '',
          legalConsentShortText: consent?.legalConsentShortText || '',
          legalConsentLongText: consent?.legalConsentLongText || '',
          isMandatory: consent?.mandatory,
          isGroup: false, //TODO: Do not have this data
          isClientArea: false, //TODO: Do not have this data
          consentAnswerCode: consent?.answer ? 'Yes' : 'No',
          consentAnswerDescription: consent?.consentAnswerDescription || '',
          consentAnswerDate: moment().format(),
        }
      }), //TODO: Do not have this data
      policyHolder: policyholderPayload,
      proposalId: createProposal?.createProposalResponse?.proposalId || '',
      signatureType: isSignatureDigital ? 'Digital' : 'Manual',
      wantsPaperless:
        formValues.docDigital === '1' || acceptConditions?.isPaperless,
      emailForPaperless:
        formValues.email ||
        policyholderAdditionalDetails?.emailContact?.email ||
        '',
    }

    return submitProposalPayload
  }

  return {
    handleSubmitProposalPayload,
  }
}
